function normalizeCategorySearchText(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

function getCategoryCount(category, countById, countCategoryItems) {
  if (typeof countCategoryItems === "function") {
    return countCategoryItems(category.id);
  }
  return Number(countById?.[category.id] || 0);
}

export function buildCategorySearchIndex(categories = [], options = {}) {
  const { countById = {}, countCategoryItems = null } = options;
  const entries = [];

  function visit(category, parentPath = [], parentIds = [], depth = 1) {
    if (!category) return;
    const id = String(category.id || category.slug || "").trim();
    const name = String(category.name || "").trim();
    if (!id || !name) return;
    const entry = {
      id,
      name,
      depth,
      parentPath,
      parentIds,
      displayPath: parentPath.length > 0 ? `${name} · ${parentPath.join(" · ")}` : name,
      count: getCategoryCount(category, countById, countCategoryItems),
      searchName: normalizeCategorySearchText(name),
    };
    entries.push(entry);

    for (const child of category.children || []) {
      visit(child, [...parentPath, name], [...parentIds, entry.id], depth + 1);
    }
  }

  for (const category of categories || []) {
    visit(category, [], [], 1);
  }

  return entries;
}

export function searchCategoryIndex(index = [], query = "") {
  const normalizedQuery = normalizeCategorySearchText(query);
  if (!normalizedQuery) return [];
  return index.filter((entry) => entry.searchName.includes(normalizedQuery));
}

export function getCategorySearchTreeState(index = [], query = "") {
  const results = searchCategoryIndex(index, query);
  const matchingIds = new Set();
  const visibleIds = new Set();

  for (const entry of results) {
    for (const parentId of entry.parentIds || []) {
      visibleIds.add(parentId);
    }
    matchingIds.add(entry.id);
    visibleIds.add(entry.id);
  }

  return {
    results,
    resultIds: results.map((entry) => entry.id),
    matchingIds,
    visibleIds,
  };
}
